import { Watcher } from '../utils/Watcher.js';
/**
 * Handler for persistance instances of a specified `type`.
 * - Accomulates applicable `PersistentDescription`'s.
 * - Watches when instance is created or disposed.
 * - Creates, populates and updates ui tabs that represent these instances.
 */
export class PersistentHandler {
    constructor(type, _viewer, _debug_layer, _config, descriptions = []) {
        var _a, _b;
        this.type = type;
        this._viewer = _viewer;
        this._debug_layer = _debug_layer;
        this._config = _config;
        this._instances = new Map();
        this._descriptions = [];
        this.name = (_a = this._config.name) !== null && _a !== void 0 ? _a : type.name;
        this._is_enabled = (_b = this._config.is_enabled) !== null && _b !== void 0 ? _b : true;
        this._descriptions = descriptions.map(description => this.to_applied_description(description));
        Watcher.subscriptions.add({ subscriber: this, watching: type });
    }
    on_object_created(instance) {
        this._instances.set(instance, this.create_tabs(instance));
    }
    on_object_disposed(instance) {
        const tabs = this._instances.get(instance);
        if (tabs) {
            tabs.forEach(tab => {
                tab.remove();
            });
        }
        this._instances.delete(instance);
        this.update_tabs();
    }
    set_enabled(is_enabled) {
        this._is_enabled = is_enabled;
        this.update_tabs();
    }
    is_enabled() {
        return this._is_enabled;
    }
    add_description(description) {
        this._descriptions.push(this.to_applied_description(description));
        this.update_tabs();
    }
    get_applied_descriptions() {
        return this._descriptions;
    }
    update_tabs() {
        this._instances.forEach((tabs, instance) => {
            tabs.forEach(tab => tab.remove());
            tabs.length = 0;
            if (this._is_enabled) {
                tabs.push(...this.create_tabs(instance));
            }
        });
    }
    dispose() {
        this._instances.clear();
        this._descriptions.length = 0;
        Watcher.subscriptions.remove(this);
    }
    get_initiators(instance) {
        const initiators = [];
        this._descriptions.forEach(applied_description => {
            if (!applied_description.is_enabled())
                return;
            const { type, initiate_tabs } = applied_description.description;
            if (initiate_tabs && instance instanceof type) {
                initiators.push(...initiate_tabs);
            }
        });
        return initiators;
    }
    create_tabs(instance) {
        return this._debug_layer.tools.persistent_tabs(instance, this.get_initiators(instance));
    }
    to_applied_description(description) {
        let { is_enabled } = description;
        return {
            description: description,
            is_enabled: () => is_enabled,
            set_enabled: (value) => {
                is_enabled = value;
                this.update_tabs();
            }
        };
    }
}
//# sourceMappingURL=PersistentHandler.js.map